import { render, staticRenderFns } from "./NoOfferRow.vue?vue&type=template&id=24a5ace6&scoped=true"
import script from "./NoOfferRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoOfferRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NoOfferRow.vue?vue&type=style&index=0&id=24a5ace6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5ace6",
  null
  
)

export default component.exports